import { connect } from 'react-redux';
import Account from '../../components/account/Account';
import type { AppState } from '../../reducers';

const mapStateToProps = (state: AppState) => ({
  distributionPartner: state.distributionPartner,
  distributionPartnerUser: state.distributionPartnerUser
});

const mapDispatchToProps = () => ({});

export type AccountPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type AccountPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(Account);
